import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Healthcare Software Development Services</h2>
            <p>
              We provide healthcare software development services that allow
              clients to utilize technological advancements for excellent
              patient care, resulting in better clinical outcomes. Whether it's
              end-to-end development or project assistance, we're ready to help
              at any level.
            </p>
            <p>Here are the healthcare development services that we offer:</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Software Development Consulting Services</h4>
                  <p>
                    Our team of healthcare IT specialists assist you in software
                    technical development, feature mapping, and regulatory
                    compliance, guaranteeing that your project not only meets
                    but exceeds expectations.
                  </p>
                  <p>
                    Additionally, we offer services to assess software costs and
                    ROI, create a marketing or adoption strategy, and plan and
                    improve a development project, ensuring that your software
                    foundation is solid, adaptable, and primed for future
                    growth.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Healthcare Software Development</h4>
                  <p>
                    We cautiously build solutions that are customized to your
                    specific needs. Whether it's improving patient management
                    systems, streamlining medical records, or deploying
                    healthcare CRM software development services, our team is
                    committed to providing customized software that enables
                    healthcare organizations to prosper in modern times.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Healthcare Software Product Development</h4>
                  <p>
                    Our team specializes in healthcare software product
                    development, pulling on years of expertise and deep domain
                    knowledge to produce innovative products that improve
                    patient care, streamline operations, and drive innovation in
                    the healthcare sector.
                  </p>
                  <p>
                    We thoroughly productize your software idea, creating a
                    distinct brand identity, feature set, and architectural
                    design that appeals to your target audience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Healthcare Software Evolution</h4>
                  <p>
                    Whether you want to improve existing functionality or
                    execute a redesigning process. Our team has the expertise to
                    solve a wide range of difficulties, from reverse engineering
                    legacy systems to methodically planning and installing
                    modernized software solutions that meet your changing needs
                    and industry standards.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>IoT Healthcare Software</h4>
                  <p>
                    We design and build IoT-based healthcare software that
                    collects patient data from smart sensors and analyzes it to
                    provide vital insights to doctors and medical staff.
                  </p>
                  <p>
                    With a special focus on compatibility and data security, our
                    IoT healthcare software integrates smoothly with existing
                    systems while protecting patient privacy.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
